var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCircleTwitter = function SvgCircleTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#circle-twitter_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M24.572 0h-24v24h24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9.79 18.096c5.658 0 8.754-4.692 8.754-8.754q.002-.198-.006-.396a6.3 6.3 0 0 0 1.536-1.596 6.2 6.2 0 0 1-1.77.486 3.1 3.1 0 0 0 1.356-1.704 6.1 6.1 0 0 1-1.956.744 3.07 3.07 0 0 0-2.244-.972 3.08 3.08 0 0 0-3 3.78 8.74 8.74 0 0 1-6.342-3.216 3.085 3.085 0 0 0 .954 4.11 3.1 3.1 0 0 1-1.392-.384v.042a3.08 3.08 0 0 0 2.466 3.018 3 3 0 0 1-.81.108q-.297 0-.576-.054a3.08 3.08 0 0 0 2.874 2.136 6.17 6.17 0 0 1-3.822 1.32 6 6 0 0 1-.732-.042 8.75 8.75 0 0 0 4.71 1.374"
  }))));
};
export { SvgCircleTwitter as ReactComponent };